import { useTranslation } from "react-i18next";

// pages/Partners.jsx
const partners = [

    {
      name: "ADISI-CAMEROUN",
      logo: require("../logos/LOGO-ADISI-Cameroun.png"),
      link: "https://adisicameroun.org/",
    },
    {
      name: "DATA-CAMEROON",
      logo: require("../logos/Capture d’écran 2025-04-25 110849.png"),
      link: "https://datacameroon.com/",
    },
  ];
  
  const Partners = () => {
    const { t } = useTranslation();
    return (
      <section className="max-w-6xl mx-auto px-4 py-20 text-center min-h-[100vh] ">
        <h1 className="text-4xl font-bold text-[#42AB3F] dark:text-white mb-12">{t("patners.title1")}</h1>
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-3  items-center justify-center">
          {partners.map((p, index) => (
            <div className="flex  items-center justify-center pl-[290px] pt-14">
              <a
              key={index}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center hover:opacity-80 transition"
            >
              <img src={p.logo} alt={p.name} className="w-24 h-auto mb-4" />
              <div className="text-gray-800 dark:text-white font-medium">{p.name}</div>
            </a>
            </div>
          ))}
        </div>
      </section>
    );
  };
  
  export default Partners;
  